import { render, staticRenderFns } from "./cSocAnalAutor.vue?vue&type=template&id=2448bc8a&scoped=true&"
import script from "./cSocAnalAutor.vue?vue&type=script&lang=js&"
export * from "./cSocAnalAutor.vue?vue&type=script&lang=js&"
import style0 from "./cSocAnalAutor.vue?vue&type=style&index=0&id=2448bc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448bc8a",
  null
  
)

export default component.exports